import { useIsHubCategoryLoadingStrategy } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsHubCategoryLoadingStrategy";
import { useShowProductFirstResults } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/useShowProductFirstResults/useShowProductFirstResults";
import { ActionName } from "@faire/web--source/common/performance/userPerceivedLoadTiming/types";

export const useCategoryPageActionName = (): ActionName => {
  const isProductFirstResults = useShowProductFirstResults();
  const isUsingHubLoadingStrategy = useIsHubCategoryLoadingStrategy();

  if (isUsingHubLoadingStrategy) {
    return "page-category-hub-logged-in";
  }

  return isProductFirstResults
    ? "page-category-product-logged-in"
    : "page-category-brand-logged-in";
};
